export var config = {
    onError: function (e) { return console.error(e); },
};
export var setConfig = function (conf) {
    Object.assign(config, conf);
};



//////////////////
// WEBPACK FOOTER
// ./~/use-sidecar/dist/es2015/config.js
// module id = 9164
// module chunks = 2